/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react';
import HubspotForm from 'react-hubspot-form';

import Spinner from 'react-scale/components/elements/spinner';
import cn from 'classnames';

function index(props) {
  return (
    <HubspotForm
      portalId="4823527"
      formId={props.formId}
      target={`.${props.formContainerCN}`}
      cssRequired={''}
      submitButtonClass={cn(
        'hs-button',
        'bg-black mt-4 text-white font-medium text-base px-6 py-3 leading-relaxed inline-block rounded-full whitespace-nowrap cursor-pointer'
      )}
      onReady={props.onReady}
      loading={<Spinner size="lg" />}
    />
  );
}

export default index;

index.defaultProps = {
  theme: 'light',
  formId: 'cd4ebc8d-46b4-4068-9ffe-a308d84d10ae',
  onReady: () => setHiddenUTMFields(),
  formContainerCN: 'hubspot-subscribe' // custom className for when there are multiple modals in the same page
};

const setHiddenUTMFields = () => {
  let utmParams = {};
  try {
    utmParams = JSON.parse(window.localStorage.getItem('utm_params') || '{}');
    Object.keys(utmParams).forEach(property => {
      const utmField = document.querySelector(`input[name=${property}]`);
      if (utmField) {
        // @ts-ignore
        utmField.value = utmParams[property] ?? '';
      }
    });
  } catch (error) {
    // NOTE: ignore error, using localStorage/sessionStorage is disabled in incognito.
  }
};
